import { render, staticRenderFns } from "./PowerSecurityTable.vue?vue&type=template&id=63c024ff&scoped=true"
import script from "./PowerSecurityTable.vue?vue&type=script&lang=js"
export * from "./PowerSecurityTable.vue?vue&type=script&lang=js"
import style0 from "./PowerSecurityTable.vue?vue&type=style&index=0&id=63c024ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c024ff",
  null
  
)

export default component.exports